import LeaderboardDashboard from '../components/statistics/LeaderboardDashboard';

function LeaderboardPage() {
  return <LeaderboardDashboard />;
}

export default LeaderboardPage;
